<template>
  <div class="head">
    <img class="logo" src="@/assets/logo.png">
    <div class="title">{{title}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Head',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      // default: 100
    }
  },
  data () {
    return {}
  },
  methods: {
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
.head {
  display: flex;
  height: 60px;
  padding: 20px;
  .logo {
    height: 20px;
  }
  .title {
    margin-left: 20px;
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head/index.vue